import React from 'react';
import '../api-details/ApiDetails.css';

export const APIDetailsHeader = ({ title }) => {
  return <div className="api-dir-pkg_api-details-title">{title}</div>;
};